export const enAgentGuiSlashPalette = {
  slashCommandPalette: "Slash commands",
  skillPickerPalette: "Skills",
  slashPaletteCommandsGroup: "Commands",
  slashPaletteCapabilitiesGroup: "Capabilities",
  slashPaletteCapabilitiesLoading: "Loading capabilities…",
  slashPaletteSkillsGroup: "Skills",
  slashPalettePluginsGroup: "Plugins",
  slashPaletteConnectorsGroup: "Connectors",
  slashPaletteConnectorConnected: "Authorized",
  slashPaletteConnectorNotConnected: "Connect",
  slashPaletteConnectorUnsupported: "Unsupported",
  slashPaletteMcpGroup: "MCP"
} as const;
